module.exports = __webpack_public_path__ + "media/12_31.de36cb8a.wav";